import { FC, ReactNode } from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import Panel from '../../elements/Panel/Panel';
import CustomSwitch from '../../common/components/CustomSwitch';

const NotificationPanel: FC<
  React.PropsWithChildren<NotificationPanelProps>
> = props => {
  const {
    toggleTooltip,
    isChecked,
    onChange,
    isDisabled,
    textPrimary,
    textSecondary,
    children,
  } = props;

  return (
    <Panel p={2} mt={2} display='flex' textAlign='left' flexDirection='column'>
      <Box display='flex' textAlign='left' alignItems='center'>
        <Tooltip arrow title={toggleTooltip}>
          <span>
            <CustomSwitch
              checked={isChecked}
              onChange={onChange}
              disabled={isDisabled}
            />
          </span>
        </Tooltip>
        <Box
          display='flex'
          textAlign='left'
          alignItems='flex-start'
          flexDirection='column'>
          <Typography color='text.primary' variant='h6'>
            {textPrimary}
          </Typography>
          <Typography color='text.primary' variant='body2'>
            {textSecondary}
          </Typography>
        </Box>
      </Box>
      {children && children}
    </Panel>
  );
};

export interface NotificationPanelProps {
  toggleTooltip: string;
  isChecked: boolean;
  onChange: () => void;
  isDisabled: boolean;
  textPrimary: string;
  textSecondary: string;
  children?: ReactNode;
}

export default NotificationPanel;
